<template>
  <popup-component v-model="showModal" :title="''" :loading="loader.on" width="650px">
    <div class="arn-outdated-warning">
      <div class="arn-outdated-warning__title">
        <h3>{{ t("title") }}</h3>
      </div>

      <div class="arn-outdated-warning__content">
        <p class="arn-outdated-warning__text">
          {{ t("subtitle") }}
        </p>
      </div>
    </div>

    <template v-slot:footer>
      <div class="arn-outdated-warning__footer">
        <v-btn @click="skipWarning" text large>{{ t("buttons.skip") }}</v-btn>
        <v-btn @click="manageArn" color="primary" large>{{ t("buttons.manage") }}</v-btn>
      </div>
    </template>
  </popup-component>
</template>

<script lang="ts">
import { defineComponent, ref, nextTick } from "@vue/composition-api"
import { createTranslationModule } from "@/plugins/i18n"
import { SESSION_KEY_SKIP_ARN_WARNING } from "@/config/constants"
import { useStore } from "@/composable/useStore"
import router, { navigate } from "@/router"
import Loader from "@/utils/loader"
import PopupComponent from "@/components/popup/PopupRoot.vue"
import "./arn-outdated-warning.scss"

export default defineComponent({
  name: "ArnOutdatedWarning",
  components: {
    PopupComponent
  },
  setup() {
    const { usersModule, organizationModule, licenseModule } = useStore()
    const t = createTranslationModule("Popup.arn")
    const showModal = ref(false)
    const loader = Loader()
    const organizationPage = "Organization"

    const skipWarning = () => {
      sessionStorage.setItem(SESSION_KEY_SKIP_ARN_WARNING, "true")
      showModal.value = false
    }

    const manageArn = () => {
      const organizationId = organizationModule.organizationDetail?.id

      if (organizationId) {
        navigate({
          name: organizationPage,
          params: { organizationId },
          query: { tab: "infrastructure" }
        })

        nextTick(() => {
          showModal.value = false
        })
      } else {
        throw Error("Organization ID is not defined")
      }
    }

    const _onCreate = async () => {
      const missingArn = organizationModule.arnOutdated
      const hasPermission = usersModule.hasAdminPermissions
      const skippedWarning = sessionStorage.getItem(SESSION_KEY_SKIP_ARN_WARNING)
      const currentPage = router.currentRoute.name
      const isOrganizationPage = currentPage === organizationPage
      const organizationOnboarded = await licenseModule.getLicenseState()

      if (!organizationOnboarded || skippedWarning || isOrganizationPage) return
      if (missingArn && hasPermission) showModal.value = true
    }

    _onCreate()

    return {
      t,
      manageArn,
      skipWarning,
      showModal,
      loader
    }
  }
})
</script>
